import { FC } from "react";
import { useData } from "data/data-provider";
import HeroSearchForm from "designs/Common/HeroSearchForm";
import MobileSearch from "../MobileSearchForm/MobileSearch";
import DynamicMobileSearch from "../DynamicMobileSearch/DynamicMobileSearch";

export interface SectionHeroProps {
  className?: string;
}

const SectionHero: FC<SectionHeroProps> = ({ className = "" }) => {
  const { banner } = useData();
  return (
    <div
      className={`nc-SectionHero3 mx-0 min-h-[100vh] sm:min-h-[80vh] flex items-center justify-center ${className}`}
      data-nc-id="SectionHero3"
      style={{
        backgroundImage: `url(${banner?.image_url})`,
        backgroundSize:
          banner?.width && banner?.height
            ? `${banner.width}px ${banner.height}px`
            : banner?.position ?? "cover",
        backgroundPosition: banner?.alignment ?? "center",
        backgroundRepeat: "no-repeat",
        position: "relative",
      }}
    >
      <div
        className="inset-x-0 text-center flex flex-col items-center mx-auto space-y-3 lg:space-y-3 xl:space-y-5"
        style={{ zIndex: 1 }}
      >
        <p
          className="font-bold text-2xl text-center max-w-7xl text-banner-heading-color bg-opacity-80 px-1 lg:bg-none lg:bg-opacity-0 lg:mx-0 mx-4 leading-none"
          dangerouslySetInnerHTML={{ __html: banner?.heading }}
        ></p>
        <p
          className="max-w-6xl text-2xl text-center text-banner-description-color px-2 md:px-6 rounded-full lg:mx-0 mx-4 font-medium"
          dangerouslySetInnerHTML={{ __html: banner?.description }}
        />

        <div
          className="hidden lg:block z-10 mb-12 lg:mb-0 w-full"
          style={{ marginTop: "0px" }}
        >
          <HeroSearchForm />
        </div>
        <div className="block lg:hidden !mx-auto px-3 w-full">
          <DynamicMobileSearch />
        </div>
      </div>
    </div>
  );
};

export default SectionHero;
